/**
 * Created by Jan on 08.05.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf  Lfl
     */
    Lfl.Animations = Lfl.Animations || {};

    (function (Animations, $, undefined) {
        /**
         * @memberOf  Lfl.Animations
         */
        Lfl.Animations.PerformanceLeveling = Animations.PerformanceLeveling || {};

        (function (PerformanceLeveling, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Animations.PerformanceLeveling, 'PerformanceLevel')) {
                return;
            }

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Static members
             |-------------------------------------------------------------------------------------------------------------------
             */

            /**
             * @type {Lfl.Animations.PerformanceLeveling.PerformanceLevel}
             */
            var currentLevel;

            function staticInit() {
                initEnumVales();
                initCurrentLevel();

                initStaticMethods();
            }

            /*
             |-------------------------------------------------------------------------
             | Enum values */

            function initEnumVales() {

                var Level = Lfl.Animations.PerformanceLeveling.PerformanceLevel;

                /*
                 |-------------------------------------------------------------------------
                 | Values */

                /**
                 * @memberOf Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 * @type Lfl.Animations.PerformanceLeveling.PerformanceLevel */
                Level.NONE = new Level('none', 0);

                /**
                 * @memberOf Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 * @type Lfl.Animations.PerformanceLeveling.PerformanceLevel */
                Level.BASIC = new Level('basic', 10);


                /**
                 * @memberOf Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 * @type Lfl.Animations.PerformanceLeveling.PerformanceLevel */
                Level.FULL = new Level('full', 20);

                /*
                 |-------------------------------------------------------------------------
                 | Freeze */

                Object.freeze(Level);
            }

            function initCurrentLevel() {
                // TODO MOBA II - if animations leveling is needed, distinguish this value based on Lfl.Mobile.isMobile.
                // - The goal would be to not use some animations on mobile devices where their impact might be too big.
                // - But it would be much easier to use uniform animations across devices.
                // -- I.e., to keep on NOT using this class.
                currentLevel = Lfl.Animations.PerformanceLeveling.PerformanceLevel.FULL;
            }


            /*
             |-------------------------------------------------------------------------
             | Methods */

            /**
             *
             */
            function initStaticMethods() {
                var Level = Lfl.Animations.PerformanceLeveling.PerformanceLevel;


                /**
                 * TODO MOBA II - duplicated across enum classes - create a super class.
                 * TODO: Merge with PS/event-status.js      
                 * - Determine which approach is superior and use that one.
                 *
                 * @memberOf Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 * @param {string} name The name of the status, can be upper or lower case.
                 * @return {Lfl.Animations.PerformanceLeveling.PerformanceLevel}
                 */
                Level.byName = function (name) {
                    return Level[Lfl.String.toUnderscore(name).toUpperCase()];
                };


                /**
                 * @memberOf Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 * @return Lfl.Animations.PerformanceLeveling.PerformanceLevel
                 */
                Level.getCurrentLevel = function () {
                    return currentLevel;
                };
            }


            /*
             |==========================================================================================================
             | Enum definition
             |==========================================================================================================
             */

            /**
             * An enumeration which describes the levels of allowed animations with regards to application's performance.
             *
             * @param {string} name
             * @param {int} absoluteLevel
             * @memberOf  Lfl.Animations.PerformanceLeveling
             * @lends  Lfl.Animations.PerformanceLeveling.PerformanceLevel
             * @constructor
             */
            Lfl.Animations.PerformanceLeveling.PerformanceLevel = function (name, absoluteLevel) {
                /*
                 |------------------------------------------------------------------------------------------------------
                 | Construction
                 |------------------------------------------------------------------------------------------------------
                 */

                /**
                 *
                 * @type {string}
                 */
                this.name = name;

                /**
                 *
                 * @type {Number}
                 */
                this.absoluteLevel = absoluteLevel;

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Whether this level permits an animation with given level.
                 *
                 * In other terms: a compare method.
                 *
                 * @param {Lfl.Animations.PerformanceLeveling.PerformanceLevel} level The level at question.
                 */
                this.doesAllow = function (level) {
                    return this.absoluteLevel >= level.absoluteLevel;
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Finalize
                 |------------------------------------------------------------------------------------------------------
                 */

                Object.freeze(this);
            };

            /*
             |-------------------------------------------------------------------------
             | Init */

            staticInit();

        }(Animations.PerformanceLeveling, jQuery));
    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
